<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Supervisor:</h4>
                <div>
                    <EmployeeTeamEditor :edit-mode="EditMode"
                                        team-role="Supervisor"
                                        :team-id="TeamRecordData.Id"
                                        :table-data="EmployeeRoleSplit.Supervisors" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Facilitator:</h4>
                <div>
                    <EmployeeTeamEditor :edit-mode="EditMode"
                                        team-role="Facilitator"
                                        :team-id="TeamRecordData.Id"
                                        :table-data="EmployeeRoleSplit.Facilitators" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Behavioral Health Specialist:</h4>
                <div>
                    <EmployeeTeamEditor :edit-mode="EditMode"
                                        team-role="Behavioral Health Specialist"
                                        :team-id="TeamRecordData.Id"
                                        :table-data="EmployeeRoleSplit.BHSs" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Parent Partner:</h4>
                <div>
                    <EmployeeTeamEditor :edit-mode="EditMode"
                                        team-role="Parent Partner"
                                        :team-id="TeamRecordData.Id"
                                        :table-data="EmployeeRoleSplit.PPs" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Clinician:</h4>
                <div>
                    <EmployeeTeamEditor :edit-mode="EditMode"
                                        team-role="Clinician"
                                        :team-id="TeamRecordData.Id"
                                        :table-data="EmployeeRoleSplit.Clinicians" />

                </div>
            </div>
        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="Wraparound.Team.People.Edit"/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import EmployeeTeamEditor from './EmployeeTeamEditor.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'TeamRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            EmployeeTeamEditor,
            EditMode
        },
        mounted() {

        },
        computed: {
            EmployeeRoleSplit: function () {
                let output = {
                    Supervisors: this.TeamRecordData.EmployeeMemberships.filter(r => r.EmployeeRole == "Supervisor"),
                    Facilitators: this.TeamRecordData.EmployeeMemberships.filter(r => r.EmployeeRole == "Facilitator"),
                    BHSs: this.TeamRecordData.EmployeeMemberships.filter(r => r.EmployeeRole == "Behavioral Health Specialist"),
                    PPs: this.TeamRecordData.EmployeeMemberships.filter(r => r.EmployeeRole == "Parent Partner"),
                    Clinicians: this.TeamRecordData.EmployeeMemberships.filter(r => r.EmployeeRole == "Clinician"),
                };
                return output;
            },
        }    
    }
</script>

<style scoped>
</style>